<template>
  <div>
    <div class="container">
      <div class="row">
        <div
          class="card mx-auto w-100"
          style="max-width: 400px;margin-top: 20px;"
        >
          <div class="card-body">
            <form>
              <div class="form-group">
                <a href="#" @click.prevent="handleFullscreen">
                  <img class="card-img-top" src="/img/solucx-logo.svg" alt="SoluCX" />
                </a>
                <h5 class="mt-4 text-center text-primary">Configuração de Tablet</h5>
              </div>
              <div class="form-group">
                <label for="idStore"
                  >Id Loja
                  <div
                    class="d-inline-flex"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Código para identificar a Unidade"
                    style="cursor:pointer;"
                  >
                    <i class="fas fa-info-circle text-primary"></i></div
                ></label>
                <input
                  type="text"
                  class="form-control"
                  id="bbb"
                  aria-describedby="idStore"
                  required
                  v-model="idStore"
                  @input="validateFields"
                  :disabled="!!$route.query.idStore === true"
                />
              </div>
              <div class="form-group">
                <label for="idEmployee"
                  >Id Funcionário
                  <div
                    class="d-inline-flex"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Código para identificar o Colaborador"
                    style="cursor:pointer;"
                  >
                    <i class="fas fa-info-circle text-primary"></i></div
                ></label>
                <input
                  type="text"
                  class="form-control"
                  aria-describedby="idEmployee"
                  required
                  v-model="idEmployee"
                  @input="validateFields"
                  :disabled="$route.query.idEmployee"
                />
              </div>
              <div class="form-group">
                <label for="apiKey"
                  >API Key
                  <div
                    class="d-inline-flex"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Token fornecido pela SoluCX para identificar a instancia no qual o sistema deve carregar as configurações"
                    style="cursor:pointer;"
                  >
                    <i class="fas fa-info-circle text-primary"></i></div
                ></label>
                <input
                  type="text"
                  class="form-control"
                  aria-describedby="apiKey"
                  required
                  v-model="apiKey"
                  @input="validateFields"
                  :disabled="$route.query.apiKey"
                />
              </div>
              <!-- <div class="form-group">
                <label for="journey">Jornada (opcional)</label>
                <input type="text" class="form-control" id="journey" aria-describedby="journey" v-model="journey" :disabled="$route.query.journey" />
              </div> -->
              <button
                type="button"
                class="btn btn-primary w-100"
                id="saveButton"
                :disabled="isDisabled"
                @click="saveData(idStore, idEmployee, apiKey, journey)"
              >
                Salvar
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $route from "vue-router";
export default {
  name: "Index",
  data() {
    return {
      idStore: "",
      idEmployee: "",
      apiKey: "",
      journey: "",
      isDisabled: true,
      isFullScreen: false,
    };
  },
  methods: {
    saveData: function(idStore, idEmployee, apiKey, journey) {
      localStorage.setItem("idStore", idStore);
      localStorage.setItem("idEmployee", idEmployee);
      localStorage.setItem("apiKey", apiKey);
      localStorage.setItem("journey", journey);
      this.redirect(idStore, idEmployee, apiKey);
    },
    redirect: function(idStore, idEmployee, apiKey) {
      window.location.replace(
        `${process.env.VUE_APP_SURVEY_URL}/tablet/${apiKey}/${idStore}/${idEmployee}`
      );
    },
    checkLocalStorage: function() {
      if (this.$route.query.clear) {
        localStorage.clear();
      } else {
        if (
          !!localStorage.getItem("idStore") === true &&
          !!localStorage.getItem("idEmployee") === true &&
          !!localStorage.getItem("apiKey")
        ) {
          this.redirect(
            localStorage.getItem("idStore"),
            localStorage.getItem("idEmployee"),
            localStorage.getItem("apiKey")
          );
        }
      }
    },
    validateFields: function() {
      if (this.idStore !== "" && this.idEmployee !== "" && this.apiKey !== "") {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    validateQueryStrings: function() {
      if (!!this.$route.query.idStore === true) {
        this.idStore = this.$route.query.idStore;
      }

      if (!!this.$route.query.idEmployee === true) {
        this.idEmployee = this.$route.query.idEmployee;
      }

      if (!!this.$route.query.apiKey === true) {
        this.apiKey = this.$route.query.apiKey;
      }

      if (!!this.$route.query.journey === true) {
        this.journey = this.$route.query.journey;
      }
    },
    openFullscreen: function() {
      const docElement = document.documentElement;
      if (docElement.requestFullscreen) {
        docElement.requestFullscreen();
      } else if (docElement.webkitRequestFullscreen) {
        docElement.webkitRequestFullscreen();
      } else if (docElement.msRequestFullscreen) {
        docElement.msRequestFullscreen();
      }
    },
    closeFullscreen: function() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    handleFullscreen: function() {
      if (!this.isFullScreen) {
        this.openFullscreen();
        this.isFullScreen = true;
      } else {
        this.closeFullscreen();
        this.isFullScreen = false;
      }
    }
  },
  mounted() {
    this.checkLocalStorage();
    this.validateQueryStrings();
  }
};
</script>
